var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dialog)?_c('div',{staticClass:"im-dialog-info"},[(_vm.group)?_c('Group',{attrs:{"data":_vm.group}}):_vm._e(),_vm._v(" "),(_vm.user)?_c('User',{attrs:{"data":_vm.user}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }